module.exports = __webpack_public_path__ + "assets/img/WP.00c2f329.png";